export const statusEnum = {
    PENDENTE: "1",
    ATRASADA: "5",
    CONCLUIDO: "2",
    MULTA: "6",
    ENVIADO: "7",
    PARALISADA: "8",
    AGUARDANDO_DADOS: "9",
    AGUARDANDO_CONFERENCIA: "10"
}